import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChatLibraryService } from '../../services/chat-library.service';
import { PosthogService } from '../../../../../services/posthog.service';
import { PosthogEventCode, PosthogEventName } from '../../../../../services/types';

const MAX_VISIBLE_LOGOS = 3;

@Component({
  selector: 'app-anchor-chip',
  standalone: true,
  imports: [NgClass, NgFor, NgIf],
  templateUrl: './anchor-chip.component.html',
  styleUrl: './anchor-chip.component.scss',
})
export class AnchorChipComponent {
  @Input({ required: true }) groupId!: string;

  @Input() groupLabel: string = '';

  @Input() creativeCount: number = 0;

  @Input() brandLogos: string[] = [];

  @Input() isActive: boolean = false;

  @Input() loading: boolean = false;

  @Output() chipClicked = new EventEmitter<string>();

  private readonly chatLibraryService = inject(ChatLibraryService);
  private readonly posthogService = inject(PosthogService);

  get visibleLogos(): string[] {
    return this.brandLogos.slice(0, MAX_VISIBLE_LOGOS);
  }

  get hiddenLogoCount(): number {
    return Math.max(this.brandLogos.length - MAX_VISIBLE_LOGOS, 0);
  }

  onClick(): void {
    if (this.loading) return;
    this.posthogService.capture(PosthogEventName.CHAT_LIBRARY_ANCHOR_CHIP_CLICKED, {
      [PosthogEventCode.GROUP_LABEL]: this.groupLabel
    });
    this.chatLibraryService.setActiveGroup(this.groupId);
    this.chatLibraryService.openPanel('chat_creative_anchor');
    this.chatLibraryService.scrollToGroup(this.groupId);
    this.chipClicked.emit(this.groupId);
  }
}
